import { FileKind } from "../../modes/define/FileKind";
import { GeneralKind } from "../../modes/define/GeneralKind";
import NormalGameManager from "../../modes/normalMode/manager/NormalGameManager";

export default class utilsCondition {

    static isMeetCond(strCond: string) {
        let itemSplits = strCond.split(FileKind.ResParseType.SUB_ITEM);
        let type = itemSplits[0];
        let TYPE = GeneralKind.ValueChangeType;
        let gameManager = NormalGameManager._instance;
        let gameData = gameManager.getGameData();
        let officialLv = gameData.m_officialLv;
        switch(type) {
            case TYPE.REACH_LEVEL: {
                let lv = Number(itemSplits[1]);
                if (officialLv >= lv) {
                    return true;
                }
            }
            break;
        }
        return false;
    }

    
}
